
import React from 'react';
import { Button } from '@/components/ui/button';
import { Database, Plus } from 'lucide-react';
import { toast } from 'sonner';
import { seedSeoData } from '@/utils/seedSeoData';
import { useQueryClient } from '@tanstack/react-query';

const SeedSeoButton = () => {
  const queryClient = useQueryClient();

  const handleSeedData = async () => {
    try {
      await seedSeoData();
      queryClient.invalidateQueries({ queryKey: ['admin-seo'] });
      toast.success('Sample SEO settings added successfully!');
    } catch (error) {
      toast.error('Failed to add sample SEO settings');
    }
  };

  return (
    <Button 
      onClick={handleSeedData}
      variant="outline"
      className="bg-blue-50 border-blue-200 text-blue-700 hover:bg-blue-100"
    >
      <Database className="w-4 h-4 mr-2" />
      Add Sample SEO Settings
    </Button>
  );
};

export default SeedSeoButton;
